import {
  PAGO_NUBE_PROVIDER_NAME,
  NUVEM_PAGO_PROVIDER_NAME,
} from 'commons/constants';
import { isNuvemPagoProvider } from 'commons/utils';

export interface useNuvemPagoRedirectResponse {
  isNuvemPagoBrazilPayment: () => boolean;
  isNuvemPagoCommonsPayment: () => boolean;
  isNuvemPagoPayment: () => boolean;
  refundReceiptURL: (id: string) => string;
  partialRefundURL: (id: string) => string;
  transactionsURL: (id: string) => string;
  listTransactionsURL: () => string;
}

function useNuvemPagoRedirect(gateway: string): useNuvemPagoRedirectResponse {
  return {
    isNuvemPagoBrazilPayment: () =>
      (gateway || '') === NUVEM_PAGO_PROVIDER_NAME,
    isNuvemPagoCommonsPayment: () =>
      (gateway || '') === PAGO_NUBE_PROVIDER_NAME,
    isNuvemPagoPayment: () => isNuvemPagoProvider(gateway || ''),
    refundReceiptURL: (id: string) => {
      if (gateway === PAGO_NUBE_PROVIDER_NAME) {
        return `/nuvempago/#/refund-receipt/${id}`;
      } else if (gateway === NUVEM_PAGO_PROVIDER_NAME) {
        return `/nuvempago#/transactions/${id}/refund-receipt?v=2`;
      } else {
        return '';
      }
    },
    partialRefundURL: (orderId: string) => {
      if (gateway === PAGO_NUBE_PROVIDER_NAME) {
        return `/admin/v2/nuvempago/#/refund/${orderId}`;
      } else if (gateway === NUVEM_PAGO_PROVIDER_NAME) {
        return `/admin/v2/nuvempago#/order-refund/${orderId}?v=2`;
      } else {
        return '';
      }
    },
    transactionsURL: (orderId: string) => {
      if (gateway === PAGO_NUBE_PROVIDER_NAME) {
        return `/admin/v2/nuvempago/#/transactions/${orderId}`;
      } else if (gateway === NUVEM_PAGO_PROVIDER_NAME) {
        return `/admin/v2/nuvempago#/order-transactions/${orderId}?v=2`;
      } else {
        return '';
      }
    },
    listTransactionsURL: () => {
      if (gateway === PAGO_NUBE_PROVIDER_NAME) {
        return `/admin/v2/nuvempago/#/`;
      } else if (gateway === NUVEM_PAGO_PROVIDER_NAME) {
        return `/admin/v2/nuvempago#/`;
      } else {
        return '';
      }
    },
  };
}

export default useNuvemPagoRedirect;
